// extracted by mini-css-extract-plugin
export default {"scrollable":"TableInfo_scrollable__df5Tz"};